module.exports = __webpack_public_path__ + "static/media/emoji-face.c482d1ba.png";